import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import axios, { CancelToken } from "axios";
import { CloudDownload } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import { SrCurrency, Typography } from "components/common";
import { INVOICE } from "../../../../constants/api";

const INVOICE_TABLE_COLUMNS = [
  {
    header: "Folio",
    isSortable: true,
    id: "folio",
  },
  {
    header: "Fecha",
    isSortable: false,
    id: "date",
  },
  {
    header: "Periodo",
    isSortable: false,
    id: "period",
  },
  {
    header: "Total",
    isSortable: false,
    id: "total",
  },
  {
    header: "XML",
    isSortable: false,
    id: "xml",
  },
  {
    header: "PDF",
    isSortable: true,
    id: "pdf",
  },
];

const makeRequest = async (source) => {
  const config = source ? { cancelToken: source.token } : {};

  try {
    const response = await axios.get(INVOICE, config);

    return response;
  } catch (error) {
    return error;
  }
};

const invoicesDataMapper = (data, formatDate) => {
  const rows = data.map((item) => ({
    id: item.id,
    folio: item.folio,
    date: formatDate(item.creationDate, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }),
    period: `${item.month} / ${item.year}`,
    total: (
      <SrCurrency value={item.total.amount} currency={item.total.currency} />
    ),
    xml: (
      <Button
        color="default"
        startIcon={<CloudDownload />}
        onClick={() => {
          window.open(item.xml + localStorage.getItem("apiToken"), "_blank");
        }}
      >
        <Typography variant="body2">XML</Typography>
      </Button>
    ),
    pdf: (
      <Button
        color="default"
        startIcon={<CloudDownload />}
        onClick={() => {
          window.open(item.pdf + localStorage.getItem("apiToken"), "_blank");
        }}
      >
        <Typography variant="body2">PDF</Typography>
      </Button>
    ),
  }));

  return rows;
};

const useInvoices = () => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const intl = useIntl();

  useEffect(() => {
    const source = CancelToken.source();

    const getData = async () => {
      const response = await makeRequest(source);

      if (response?.data?.success) {
        const data = response.data.result;

        setRows(invoicesDataMapper(data, intl.formatDate));
      }

      setLoading(false);
    };

    getData();

    return () => {
      source.cancel("Component unmounted");
    };
  }, [intl.formatDate]);

  return {
    loading,
    invoicesColumns: INVOICE_TABLE_COLUMNS,
    invoicesRows: rows,
    getInvoices: makeRequest,
  };
};

export default useInvoices;
